/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Header_viewer = {|
  +allTransactions?: ?{|
    +totalResults: ?number;
  |};
  +initiatedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +submittedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +confirmedTransactionsMostRecent?: ?{|
    +totalResults: ?number;
  |};
  +tradeChatEmail?: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string;
    |}>;
  |}>;
  +vipChatEmail?: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string;
    |}>;
  |}>;
  +confirmedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +user?: ?{|
    +firstSessionDate: ?string;
    +isTrade: ?boolean;
    +hasVipPermission: ?boolean;
    +profile: ?{|
      +email: ?string;
      +zipCode: ?string;
      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
    |};
    +serviceId: ?string;
    +totalMessagesToDealers: ?number;
    +tradeFirm: ?{|
      +serviceId: ?string;
      +tier: ?"TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "P_AND_M" | "UNKNOWN";
    |};
    +verifiedTradeStatus: ?string;
    +activePromotion: ?{|
      +serviceId: ?string;
    |};
    +isVip: ?boolean;
    +createdDate: ?string;
    +roles: ?{|
      +roleList: ?$ReadOnlyArray<?{|
        +name: ?string;
        +createdDate: ?string;
        +userData: ?{|
          +userStatus: ?{|
            +name: ?string;
          |};
        |};
      |}>;
    |};
    +isVerifiedTrade: ?boolean;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "showMarketingMessages",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TopBar_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "BottomBar_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "showMarketingMessages",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "MessageBanner_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.initiated",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.submitted",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "confirmedTransactionsMostRecent",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.confirmed",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "tradeChatEmail",
          "args": [
            {
              "kind": "Literal",
              "name": "relationshipType",
              "value": "VIP",
              "type": "relationshipType!"
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds",
              "type": "[String]!"
            }
          ],
          "concreteType": "UserRelationship",
          "name": "userRelationships",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": null,
              "name": "userDataB",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "VipRepData",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "email",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "vipChatEmail",
          "args": [
            {
              "kind": "Literal",
              "name": "relationshipType",
              "value": "TRADE",
              "type": "relationshipType!"
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds",
              "type": "[String]!"
            }
          ],
          "concreteType": "UserRelationship",
          "name": "userRelationships",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": null,
              "name": "userDataB",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "TradeRepData",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "email",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "confirmedTransactions",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userIds",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 0,
              "type": "Int"
            },
            {
              "kind": "Literal",
              "name": "sort",
              "value": "createdDate asc",
              "type": "String"
            },
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.confirmed",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "verifiedTradeStatus",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstSessionDate",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": "hasVipPermission",
              "args": [
                {
                  "kind": "Literal",
                  "name": "name",
                  "value": "B_VIP_CHECKOUT",
                  "type": "String!"
                }
              ],
              "name": "hasPermission",
              "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "email",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "zipCode",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "currency",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalMessagesToDealers",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmType",
              "name": "tradeFirm",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "tier",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": "isTrade",
              "args": [
                {
                  "kind": "Literal",
                  "name": "name",
                  "value": "B_TRADE_CHECKOUT",
                  "type": "String!"
                }
              ],
              "name": "hasPermission",
              "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Promotion",
              "name": "activePromotion",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "serviceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "isVip",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "createdDate",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "UserRoles",
              "name": "roles",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "name": "roleList",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "createdDate",
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "UserRoleData",
                      "name": "userData",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "UserRoleUserData",
                          "name": "userStatus",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "name",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "isVerifiedTrade",
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "TopBar_user",
              "args": null
            },
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "showMarketingMessages",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "MessageBanner_user",
                  "args": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
